import { render, staticRenderFns } from "./IntegracionExpedienteIncode.vue?vue&type=template&id=1fcc33cb&"
import script from "./IntegracionExpedienteIncode.vue?vue&type=script&lang=js&"
export * from "./IntegracionExpedienteIncode.vue?vue&type=script&lang=js&"
import style0 from "./IntegracionExpedienteIncode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports